/** @format */

import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { fromEvent, Subject } from "rxjs";
import { delay, takeUntil } from "rxjs/operators";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { SeatService } from "../../../services/seat.service";
import { ConfigurationService } from "../../../services/configuration.service";
interface IWindowMessage {
  data: {
    app: string;
    eventType: string;
    value: NsEmpWebExpData.ISeatChange;
  };
}

@Component({
  selector: "[mis-employee-web-exp-seat]",
  templateUrl: "./seat.component.html",
  styleUrls: ["./seat.component.scss"]
})
export class SeatComponent implements OnInit, OnDestroy {
  @ViewChild("frameElement") frameElement: ElementRef;
  frameSource = this.seatSvc.source.pipe(delay(300));
  messageStream = fromEvent<IWindowMessage>(window, "message");
  endObs = new Subject<void>();
  constructor(private seatSvc: SeatService, private configSvc: ConfigurationService) {}

  ngOnInit(): void {
    this.messageStream.pipe(takeUntil(this.endObs)).subscribe(res => {
      const message = res.data;
      if (message.app === "FLOOR_PLAN_LIBRARY") {
        if (message.eventType === "OFFICE_CHANGE") {
          console.log("office changed while searching ", message);
          if (confirm("Searched employee booking is in different office, Do you want to switch office ?")) {
            this.seatSvc.changeOffice(message.value);
          }
        }
      }
      if (message?.eventType === "SEAT_SELECTED") {
        if (this.configSvc.isMobile) {
          this.seatSvc.temperarySeat.next(message.value);
          return;
        }
        this.seatSvc.changeSeat(message.value);
      }
    });
  }

  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }
}
